import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import { H5 } from 'text';


const SegmentedControl = ({ isInStock, className, setQuantity, canEdit, ...props }) => {
  const [checked, setChecked] = useState(false);
  const inStockRef = useRef();
  const outOfStockRef = useRef();

  useEffect(() => {
    switch (checked) {
      case false:
        inStockRef.current.style.fontFamily = 'GT-America-Standard-Medium';
        outOfStockRef.current.style.fontFamily = 'GT-America-Standard-Regular';
        break;
      case true:
        outOfStockRef.current.style.fontFamily = 'GT-America-Standard-Medium';
        inStockRef.current.style.fontFamily = 'GT-America-Standard-Regular';
        break;
    }
  }, [checked]);

  useEffect(() => {
    const initialCheckedProp = isInStock === 1 ? false : true;
    setChecked(initialCheckedProp)
  }, [isInStock]);

  const handleUpdateStock = (checked) => {
    if(!canEdit){
      return;
    }
    // needs to be 1 or 0 to update product quantity
    const quantity = checked === false ? 1 : 0;
    setChecked(checked);
    setQuantity(quantity)
   }

  return (
    <div className={classnames(styles.checkboxContainer, className)} {...props}>
      <label
        htmlFor="segmentedControl"
        ref={inStockRef}
        style={{
          position: 'absolute',
          left: '46px',
          top: '6px',
          color: 'white',
          zIndex: '10'
        }}
      >
        <H5>In Stock</H5>
      </label>
      <label
        ref={outOfStockRef}
        htmlFor="segmentedControl"
        style={{
          position: 'absolute',
          right: '34px',
          top: '6px',
          color: 'white',
          zIndex: '10'
        }}
      >
        <H5>Out of Stock</H5>
      </label>
      <input
        id="segmentedControl"
        type="checkbox"
        value={checked}
        checked={checked}
        onChange={() => handleUpdateStock(!checked)}
      />
    </div>
  );
};

export default SegmentedControl;
